import {createAction, props} from "@ngrx/store";
import {MenuItemOrder} from "../../../../@domain/menu-order";

export const SET_MENU_ITEM_ORDER = createAction('[MENU] SET_MENU_ITEM_ORDER', props<{payload: MenuItemOrder[]}>())
